<template>
    <v-app>
        <v-content style="background: white;">
            <div class="container" style="z-index: 1;">
                <div class="row">
                    <div class="col-md-12">
                        <div class="layout column align-start">
<!--                            <v-img v-if="logo" class="mb-5" contain :src="$root.getSrc(logo)" alt="Vue Material Admin" width="70" />-->
                        </div>
                    </div>
                    <div class="col-md-12 mt-16">
                        <v-layout align-start justify-center>
                            <v-flex>
                                <transition name="fade-in" mode="out-in">
                                    <router-view :key="$route.path"></router-view>
                                </transition>
                            </v-flex>
                        </v-layout>
                    </div>
                </div>

            </div>

        </v-content>
        <errors-component></errors-component>
    </v-app>
</template>

<script>
    import ErrorsComponent from './components/errors'
    export default {
        components:{ErrorsComponent},
        data: () => ({}),

        methods: {},
        computed:{
            logo(){
                return this.$store.getters.logo;
            }
        },
    }
</script>
<style lang="scss">
    #app{
        @import "scss/custom.scss";
    }


    .split-bg {
        height: 50%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        content: "";
        z-index: 0;
    }
</style>
